import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateBlogCategory } from "../../api/apiBlogCategories";
import parseError from "../../utils/parseError";
import { useNavigate } from "react-router-dom";

/**
 * Hook لتحديث تصنيف
 */
export function useUpdateBlogCategory() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const {
        mutate: updateBlogCategoryMutate,
        isPending,
    } = useMutation({
        mutationFn: ({ id, data }) => updateBlogCategory(id, data),
        onSuccess: (response) => {
            toast.success(response.message || "Updated successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-categories"] });
            navigate('/blog/categories');
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update blog category");
        },
    });

    return {
        updateBlogCategoryMutate,
        isPending,
    };
}
